import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
    selector: '[roDisabled]',
})
export class RoDisabledDirective {
    @Input() roDisabled = false;

    @HostBinding('class.ro-disabled')
    get applyClasses() {
        return this.roDisabled;
    }
}
